// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// --- RxJs
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

// --- HS Code
import { AppService, CheckSessionService, OidcService } from '../services';
import { environment } from '../../../environments/environment';

// #endregion

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const appService: AppService = inject(AppService);
    const checkSessionService: CheckSessionService = inject(CheckSessionService);
    const oidcService: OidcService = inject(OidcService);
    const router: Router = inject(Router);

    return forkJoin([oidcService.waitForAuthenticationLoaded(), oidcService.identity$]).pipe(
      map(([isAuthenticating, user]) => {
        if (!isAuthenticating && user && !user.expired) {
          return true;
        }

        return router.createUrlTree(['/login']);
      })
    );
}
